import type { ReactNode } from 'react';

interface Props {
  children: ReactNode;
  className?: string;
}

export default function A4PrintContainer({ children, className = '' }: Props) {
  return (
    <>
      <style>{`
        @media print {
          body * { visibility: hidden !important; }
          .a4-print-root, .a4-print-root * { visibility: visible !important; }
          .a4-print-root {
            position: absolute; left: 0; top: 0;
            width: 100%; max-width: none;
            margin: 0; padding: 0;
            box-shadow: none !important;
            border: none !important;
            background: white !important;
          }
          .no-print,
          aside, header, footer,
          [aria-label="Emergency SOS"],
          nav { display: none !important; }

          @page {
            size: A4 portrait;
            margin: 12mm;
          }

          .a4-section { page-break-inside: avoid; }
          .a4-page-break { page-break-before: always; }
          .a4-keep-together { page-break-inside: avoid; }

          tr { page-break-inside: avoid; }
          thead { display: table-header-group; }

          * { -webkit-print-color-adjust: exact !important; print-color-adjust: exact !important; }

          .a4-watermark { opacity: 0.12 !important; }
          .a4-watermark p { font-size: 64px !important; }
        }

        /* Screen preview — A4 proportions */
        .a4-print-root {
          font-family: 'Inter', system-ui, -apple-system, sans-serif;
        }

        /* Prevent table overflow */
        .a4-print-root table {
          max-width: 100%;
        }
        /* Long IDs wrap safely */
        .a4-print-root .font-mono {
          overflow-wrap: anywhere;
          word-break: break-all;
        }
        @media (max-width: 640px) {
          .a4-print-root table {
            font-size: 8px;
          }
        }
        @media print {
          .a4-print-root table {
            font-size: 9px;
          }
        }
      `}</style>
      <div className={`a4-print-root bg-white w-full max-w-[210mm] mx-auto shadow-lg border border-gray-200 overflow-x-auto print:overflow-hidden ${className}`}>
        {children}
      </div>
    </>
  );
}
